import { connect } from "./ComponentEx";
import { extend } from "../ExtensionProvider";
import { truthy } from "../util/util";
import * as _ from "lodash";
import * as React from "react";
import { setInterval } from "timers";
class Banner extends React.Component {
    mRef;
    mBanners;
    mCurrentBanner = 0;
    componentDidMount() {
        setInterval(this.cycle, this.props.cycleTime || 15000);
    }
    render() {
        const { bannerProps, className, objects, style } = this.props;
        this.mBanners = objects.filter((obj, idx) => obj.options.condition === undefined ||
            obj.options.condition(bannerProps[idx]));
        const classes = className !== undefined ? className.split(" ") : [];
        classes.push("banner");
        return this.mBanners.length > 0 ? (React.createElement("div", { className: classes.join(" "), style: style, ref: this.setRef }, this.mBanners.map(this.renderBanner))) : null;
    }
    renderBanner = (banner, idx) => {
        return (React.createElement("div", { key: idx, className: idx === this.mCurrentBanner ? "active" : undefined },
            React.createElement(banner.component, null)));
    };
    setRef = (ref) => {
        this.mRef = ref;
    };
    cycle = () => {
        if (truthy(this.mRef)) {
            const prev = this.mRef.childNodes.item(this.mCurrentBanner);
            prev?.attributes?.removeNamedItem?.("class");
            this.mCurrentBanner = (this.mCurrentBanner + 1) % this.mBanners.length;
            const attr = document.createAttribute("class");
            attr.value = "active";
            const current = this.mRef.childNodes.item(this.mCurrentBanner);
            current?.attributes?.setNamedItem?.(attr);
        }
    };
}
function registerBanner(instanceGroup, group, component, options) {
    if (instanceGroup === group) {
        return { component, options };
    }
    else {
        return undefined;
    }
}
let lastBannerProps;
function mapStateToProps(state, ownProps) {
    const bannerProps = (ownProps.objects || []).reduce((prev, banner, idx) => {
        const props = banner.options.props;
        if (props !== undefined) {
            prev[idx] = Object.keys(props).reduce((propsPrev, key) => {
                propsPrev[key] = props[key](state);
                return propsPrev;
            }, {});
        }
        return prev;
    }, {});
    if (!_.isEqual(lastBannerProps, bannerProps)) {
        lastBannerProps = bannerProps;
    }
    return {
        bannerProps: lastBannerProps,
    };
}
export default extend(registerBanner, "group")(connect(mapStateToProps)(Banner));
